import React from 'react';
import styled from '@emotion/styled';
import BackButton from '@components/UI/BackButton/BackButton';

const StyledPageHead = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
  gap: 20px;

  @media (max-width: 1200px) {
    margin-bottom: 8px;
  }
`;

type PageHeadProps = {
  backUrl?: string;
  backText: string;
  backDesc?: React.ReactNode;
  backArrow?: boolean;
  buttonGroup?: React.ReactNode;
  extra?: React.ReactNode;
};

const PageHead = ({ backUrl, backText, backDesc, backArrow, buttonGroup, extra }: PageHeadProps) => (
  <StyledPageHead>
    <BackButton url={backUrl} text={backText} desc={backDesc} extra={extra} arrow={backArrow} data-testid="back" />
    {buttonGroup && <div>{buttonGroup}</div>}
  </StyledPageHead>
);

export default PageHead;
